module.exports = {
  title: "Caution Alert",
  description:
    "Terms and Conditions of AutoRebalance service , Backtest and Forwardtest cannot guarantee future results or profits. Services contain risk. Not recommended to use it without research. Users should study risks before deciding to use services. Call Center +66927268666",
  button_text: "I understand and agreed",
};
